/**
 * cm_app_file 업로드/다운로드 (HWP·첨부)
 */
import api from 'services/api';
import { isBdApiEnabled } from 'config/bdApiConfig';

export async function uploadAppFile({ bucket, objectKey, file, fileName }) {
  const fd = new FormData();
  fd.append('bucket', bucket);
  fd.append('objectKey', objectKey);
  if (fileName) fd.append('fileName', fileName);
  fd.append('file', file);
  const res = await api.postForm('/files', fd);
  const data = res?.data || {};
  if (String(data.Msg || '').toLowerCase() !== 'success') {
    throw new Error(data.Msg || '파일 업로드 실패');
  }
  return data;
}

export async function downloadAppFile(bucket, objectKey) {
  const q = `bucket=${encodeURIComponent(bucket)}&objectKey=${encodeURIComponent(objectKey)}`;
  const res = await api.getBlob(`/files?${q}`);
  if (!res?.data || res.status === 404) return null;
  return res.data;
}

export async function deleteAppFile(bucket, objectKey) {
  const q = `bucket=${encodeURIComponent(bucket)}&objectKey=${encodeURIComponent(objectKey)}`;
  const res = await api.post(`/files/delete?${q}`, {});
  return res?.data;
}

export { isBdApiEnabled };
